import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const client = axios.create({ baseURL: BASE });

// Attach the consultant bearer token (if signed in) to every request.
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("crm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On an expired/invalid CRM session, drop the token and bounce to login.
client.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && localStorage.getItem("crm_token")) {
      localStorage.removeItem("crm_token");
      if (window.location.pathname.startsWith("/crm") && window.location.pathname !== "/crm/login") {
        window.location.replace("/crm/login");
      }
    }
    return Promise.reject(error);
  }
);

export const money = (n) =>
  n == null || isNaN(n) ? "—" : "$" + Math.round(n).toLocaleString("en-AU");

export const weekly = (n) =>
  n == null || isNaN(n) ? "—" : "$" + Math.round(n).toLocaleString("en-AU");

export const api = {
  stages: () => client.get("/journey/stages").then((r) => r.data),
  investorRegions: () => client.get("/investor/regions").then((r) => r.data),
  createSession: (payload) => client.post("/sessions", payload).then((r) => r.data),
  getSession: (id) => client.get(`/sessions/${id}`).then((r) => r.data),
  listSessions: () => client.get("/sessions").then((r) => r.data),
  patchSession: (id, payload) => client.patch(`/sessions/${id}`, payload).then((r) => r.data),
  transcribe: (id, blob) => {
    const fd = new FormData();
    fd.append("audio", blob, "chunk.webm");
    return client.post(`/sessions/${id}/transcribe`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
  analyze: (id, transcript) => client.post(`/sessions/${id}/analyze`, { transcript }).then((r) => r.data),
  suggest: (id, transcript) => client.post(`/sessions/${id}/suggest`, { transcript }).then((r) => r.data),
  finance: (id, payload) => client.post(`/sessions/${id}/finance`, payload).then((r) => r.data),
  budget: (id, payload) => client.post(`/sessions/${id}/budget`, payload).then((r) => r.data),
  match: (id) => client.post(`/sessions/${id}/match`).then((r) => r.data),
  wealth: (id, payload) => client.post(`/sessions/${id}/wealth`, payload).then((r) => r.data),
  emailJourney: (id, payload) => client.post(`/sessions/${id}/email-journey`, payload).then((r) => r.data),
  sendJourney: (id) => client.post(`/sessions/${id}/send-journey`).then((r) => r.data),
  floorplans: () => client.get("/floorplans").then((r) => r.data),
  createFloorplan: (fp) => client.post("/admin/floorplans", fp).then((r) => r.data),
  deleteFloorplan: (fid) => client.delete(`/admin/floorplans/${fid}`).then((r) => r.data),
  importFloorplans: (payload) => client.post("/admin/floorplans/import", payload).then((r) => r.data),
  reseed: () => client.post("/admin/floorplans/seed").then((r) => r.data),
  getAssumptions: () => client.get("/admin/assumptions").then((r) => r.data),
  putAssumptions: (a) => client.put("/admin/assumptions", a).then((r) => r.data),
  // --- consultant auth + CRM ---
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  googleSession: (sessionId) =>
    client.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } }).then((r) => r.data),
  crmClients: () => client.get("/crm/clients").then((r) => r.data),
  crmClient: (id) => client.get(`/crm/clients/${id}`).then((r) => r.data),
  crmSetStatus: (id, follow_up_status) => client.patch(`/crm/clients/${id}/status`, { follow_up_status }).then((r) => r.data),
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
